import React, { Component } from 'react'
import style from './style.module.less'
import { observer, Provider } from 'mobx-react'
import CreateForm from './CreateForm'
import { Link } from 'react-router'
import Store from './store'
import { HeaderView } from '@merchant-backend/common-components'
import { PATH_HOTEL_MENU_MANAGE } from '@components/Hotel/constant'
import CourseGuide from '@components/LocalMerchant/Common/CourseGuide'
import { isNewOpen } from '@util'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const { id } = this.props.params
    this.store = new Store(id)
  }

  render() {
    const header = [
      <Link to={PATH_HOTEL_MENU_MANAGE}>菜单管理</Link>,
      '发布菜单'
    ]
    return (
      <Provider store={this.store}>
        <HeaderView
          header={header}
          contentStyle={{ padding: 0, background: '#F2F3F6' }}
          title={'发布菜单'}
        >
          {isNewOpen() && <CourseGuide taskId="6" />}
          <div className={style.createMenu}>
            <CreateForm />
          </div>
        </HeaderView>
      </Provider>
    )
  }
}
